export default "<div>\n  <i class=\"fa fa-4x fas fa-spin fa-spinner\"></i>\n</div>\n<div class=\"mt-2\">Loading...</div>\n";